/* Filter tasks array to remove duplicate task items */
function filterTasks(orgTask) {
  const filteredTasks = [];
  orgTask.forEach((task) => {
    if (filteredTasks.length) {
      const exist = filteredTasks.find((x) => x.TASK === task.TASK);
      if (exist) {
        filteredTasks[filteredTasks.length - 1]['LEARNING_RESOURCES'].push({
          LEARNING_RESOURCE: task['LEARNING_RESOURCE'],
          LEARNING_RESOURCE_URL: task['RESOURCE_URL'],
        });
        return; //go to next iteration
      }
    }
    filteredTasks.push({
      ...task,
      LEARNING_RESOURCES: [
        {
          LEARNING_RESOURCE: task['LEARNING_RESOURCE'],
          LEARNING_RESOURCE_URL: task['RESOURCE_URL'],
        },
      ],
    });
  });
  return filteredTasks;
}

function sortUnitsByStartDate(units) {
  if (units.length <= 0) return [];
  const unitsRef = [...units];
  const sortedUnits = unitsRef.sort((a, b) => {
    const aTime = new Date(a.unit_start_date).getTime();
    const bTime = new Date(b.unit_start_date).getTime();
    if (aTime > bTime) {
      return 1;
    } else if (bTime > aTime) {
      return -1;
    }
    return 0;
  });
  return sortedUnits;
}

export { filterTasks, sortUnitsByStartDate };
